import { useQuery } from '@tanstack/react-query';

import { api } from '~/lib/api';
import type { AppSettingsResponse } from '~/lib/api';

const QUERY_KEY = ['app-settings'] as const;

export function useAppSettings() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => api.get<AppSettingsResponse>('/api/settings'),
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
}
